import { ComponentPropsWithoutRef, forwardRef, ReactNode } from "react";
import clsx from "clsx";
import ErrorBoundary from "../error-boundary";

import styles from "./code.module.scss";

type CodeProps = {
  /** Optional extra class(es) */
  className?: string;
  /** The code */
  children: ReactNode;
} & ComponentPropsWithoutRef<"code">;

const Code = forwardRef<HTMLElement, CodeProps>(
  ({ className, children, ...rest }, ref) => {
    const classes = [styles.code, className];

    return (
      <code {...rest} ref={ref} className={clsx(classes)}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </code>
    );
  }
);

Code.displayName = "Code";

export default Code;
